<template>
	<div>
		<a-tabs default-active-key="1" @change="callback">
			<a-tab-pane key="1">
				<span slot="tab">
					<a-icon type="user" />
					商会成员
				</span>
				<a-table :columns="columns" :data-source="data">
					<a slot="name" slot-scope="text">{{ text }}</a>
					<span slot="customTitle">
						<a-icon type="shop" />
						企业名称
					</span>
					<span slot="avatar" slot-scope="text, record"><a-avatar :src="text" /></span>
					<span slot="action" slot-scope="text, record">
						<a-popconfirm title="将删除该条商会公告,是否删除？" @confirm="deleteMember(record.id)" @cancel="cancel" okText="删除" cancelText="取消">
							<a-button type="danger">删除</a-button>
						</a-popconfirm>
					</span>
				</a-table>
			</a-tab-pane>
			<a-tab-pane key="2" force-render>
				<span slot="tab">
					<a-icon type="usergroup-add" />
					申请列表
				</span>
				<a-table :columns="columns" :data-source="data">
					<a slot="name" slot-scope="text">{{ text }}</a>
					<span slot="customTitle">
						<a-icon type="smile-o" />
						企业名称
					</span>
					<span slot="avatar" slot-scope="text, record"><a-avatar :src="text" /></span>
					<span slot="action" slot-scope="text, record">
						<a-button type="primary" @click="passMember(record.id)">通过</a-button>
						<a-button @click="deleteMember(record.id)" style="margin-left: 15px;" type="danger">删除</a-button>
					</span>
				</a-table>
			</a-tab-pane>
			<a-tab-pane key="3">
				<span slot="tab">
					<a-icon type="usergroup-add" />
					不通过
				</span>
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
const columns = [
	{
		dataIndex: 'companyName',
		key: 'companyName',
		slots: { title: 'customTitle' },
		scopedSlots: { customRender: 'companyName' }
	},
	{
		title: '电话',
		dataIndex: 'phone',
		key: 'phone'
	},
	{
		title: '企业地址',
		dataIndex: 'address',
		key: 'address'
	},
	{
		title: '头像',
		key: 'avatar',
		dataIndex: 'avatar',
		scopedSlots: { customRender: 'avatar' }
	},
	{
		title: '主营产品',
		dataIndex: 'main',
		key: 'main'
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' }
	}
];

import api from '../../api/Api.js';
export default {
	data() {
		return {
			data: [],
			columns,
			status: 1,
			page: 0
		};
	},
	mounted() {
		this.getMemberList();
	},
	methods: {
		getMemberList() {
			const that = this;
			let url = 'api/commerce/v1/admin/getCommerceMemberList';
			let parm = {
				page: this.page,
				status: this.status
			};
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					rest.data.forEach((item, index, array) => {
						item.key = index;
					});
					that.data = rest.data;
					console.log('=====================');
					console.log(rest.data);
					console.log('=====================');
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		passMember(accountId) {
			const that = this;
			let url = 'api/commerce/v1/admin/passMember';
			let parm = {
				accountId: accountId
			};
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('已通过！');
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		deleteMember(accountId) {
			const that = this;
			
			this.$confirm({
				title: '确定删除吗？',
				content: '删除后改成员将不会出现在商会成员列表，确认删除吗?',
				onOk() {
					let url = 'api/commerce/v1/admin/deleteMember';
					let parm = {
						accountId: accountId
					};
					api.postRequest(url, parm, res => {
						const rest = res.data;
						if (rest.status == 200) {
							that.$message.success('删除成功！');
							that.getMemberList();
						} else {
							that.$message.error('服务器内部错误！');
						}
					});
				},
				onCancel() {
					that.$message.warning('你点击了取消');
				}
			})
		},
		callback(e) {
			if (e == 1) {
				this.status = 1;
			} else {
				this.status = 0;
			}
			this.getMemberList();
		},
		cancel(){
			
		}
	}
};
</script>

<style></style>
